import { Helpers } from '../../helpers';
import { IPad } from '../../interfaces/ipad';
import { Area } from '../area';
import { Asset } from '../asset';
import { AssetTeam } from '../asset-team';
import { CellarDesign } from '../cellar-design';
import { DrillGroup } from '../drill-group';
import { FracGroup } from '../frac-group';
import { InjectionLineStatus } from '../injection-line-status';
import { PadDesign } from '../pad-design';
import { ProjectDrillingParameter } from '../project-drilling-parameter';
import { Scenario } from '../scenario';
import { ScenarioWell } from '../scenario-well';
import { Well } from '../well';

export class PadBase {
  PadId: number;
  Name: string;
  AssetTeamId: number;
  InjectionLineExists: boolean;
  InjectionLineStatusId: number | null;
  SisterPadId: number | null;
  LegacyAssetTeamId: number | null;
  TankBatteryAreaId: number | null;
  PadDesignId: number | null;
  PadExists: boolean | null;
  TankBatteryId: number | null;
  SysActionUID: string | null;
  SysStartTime: Date;
  SysEndTime: Date;
  GeoCenter: object | null;
  EstimatedWellsOnPad: number | null;
  CellarDesignId: number | null;
  ScenarioId: number | null;
  IsDeleted: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  AssetId: number | null;

  DrillGroups_Pad?: Array<DrillGroup> | null;
  FracGroups_Pad?: Array<FracGroup> | null;
  ProjectDrillingParameters_Pad?: Array<ProjectDrillingParameter> | null;
  ScenarioWells_Pad?: Array<ScenarioWell> | null;
  Wells_Pad?: Array<Well> | null;
  Asset?: Asset;
  AssetTeam?: AssetTeam;
  CellarDesign?: CellarDesign;
  InjectionLineStatus?: InjectionLineStatus;
  PadDesign?: PadDesign;
  Scenario?: Scenario;
  LegacyAssetTeam?: AssetTeam;
  Area?: Area;

  constructor(item?: IPad) {
    if (item) {

      this.PadId = item.PadId;
      this.Name = item.Name;
      this.AssetTeamId = item.AssetTeamId;
      this.InjectionLineExists = item.InjectionLineExists;
      this.InjectionLineStatusId = item.InjectionLineStatusId;
      this.SisterPadId = item.SisterPadId;
      this.LegacyAssetTeamId = item.LegacyAssetTeamId;
      this.TankBatteryAreaId = item.TankBatteryAreaId;
      this.PadDesignId = item.PadDesignId;
      this.PadExists = item.PadExists;
      this.TankBatteryId = item.TankBatteryId;
      this.SysActionUID = item.SysActionUID;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.GeoCenter = item.GeoCenter;
      this.EstimatedWellsOnPad = item.EstimatedWellsOnPad;
      this.CellarDesignId = item.CellarDesignId;
      this.ScenarioId = item.ScenarioId;
      this.IsDeleted = item.IsDeleted;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.AssetId = item.AssetId;

      this.DrillGroups_Pad = Helpers.createClassArray(DrillGroup, item.DrillGroups_Pad);
      this.FracGroups_Pad = Helpers.createClassArray(FracGroup, item.FracGroups_Pad);
      this.ProjectDrillingParameters_Pad = Helpers.createClassArray(ProjectDrillingParameter, item.ProjectDrillingParameters_Pad);
      this.ScenarioWells_Pad = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_Pad);
      this.Wells_Pad = Helpers.createClassArray(Well, item.Wells_Pad);
      this.Asset = new Asset(item.Asset);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.CellarDesign = new CellarDesign(item.CellarDesign);
      this.InjectionLineStatus = new InjectionLineStatus(item.InjectionLineStatus);
      this.PadDesign = new PadDesign(item.PadDesign);
      this.Scenario = new Scenario(item.Scenario);
      this.LegacyAssetTeam = new AssetTeam(item.LegacyAssetTeam);
      this.Area = new Area(item.Area);
    }
  }
}